import { SIDE_BAR_CLASS, MAIN_CONTENT_CLASS } from "#utils/constants";
import { useSize } from "ahooks";

export default function useLayoutContentWidth() {
  const taggetSider = document.querySelector(SIDE_BAR_CLASS);
  const size = useSize(taggetSider);

  return window.innerWidth - size?.width - 1;
}
